import { SAVE_TICKET, TICKET_DETAILS} from "./type";

const initialState = {
    saveTicketDetails:[],
    getTicketDetails: []
};

const RaiseTicket = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case SAVE_TICKET:
            return {
                ...state,
                saveTicketDetails: payload,
            };
        case TICKET_DETAILS:
            return {
                ...state,
                getTicketDetails: payload,
            };
        default:
            return {...state};
    }
};

export default RaiseTicket;